import { Icons } from '@/assets/icons/icons';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { SidePanel } from '@/design-system-v2/side-panel';
import { cn } from '@/lib/utils';

interface FilterDropdownTriggerProps {
  'aria-label': string;
  activeLabel?: string | null;
  compact?: boolean;
}

export const FilterDropdownTrigger = ({
  'aria-label': ariaLabel,
  activeLabel,
  compact = false,
}: FilterDropdownTriggerProps) => (
  <DropdownMenu.Trigger asChild>
    {compact ? (
      <SidePanel.Action
        icon={Icons.listFilter}
        label={activeLabel ? `${ariaLabel}: ${activeLabel}` : ariaLabel}
        active={!!activeLabel}
      />
    ) : (
      <button
        type="button"
        aria-label={activeLabel ? `${ariaLabel}: ${activeLabel}` : ariaLabel}
        className={cn(
          'inline-flex max-w-48 shrink-0 items-center justify-center gap-1.5 rounded-lg border border-border bg-surface px-3 text-sm',
          'text-foreground-muted hover:bg-secondary-hover hover:text-foreground',
          'data-[state=open]:border-border-strongest data-[state=open]:!bg-surface data-[state=open]:text-foreground',
          'focus-ring transition-colors',
          activeLabel && 'text-foreground'
        )}
      >
        <Icons.listFilter className="size-3.5 shrink-0 opacity-75" />
        {activeLabel && (
          <>
            <span className="truncate">{activeLabel}</span>
            <Icons.chevronDown className="size-3 shrink-0 opacity-70" />
          </>
        )}
      </button>
    )}
  </DropdownMenu.Trigger>
);
